import store from '../store';
import { setCurrentCaption } from 'store/actions/student';

let DISPATCH_INTERVAL = null;

const syncAudioCaption = (audio, captions) => {
  // Store polling interval id so we can pause/resume
  const getTimeStamp = () => {
    if (audio.playing()) {
      const timeStamp = audio.seek();
      displayCaption(timeStamp, captions);
      DISPATCH_INTERVAL = setTimeout(getTimeStamp, 100);
    }
  };

  // Start polling
  getTimeStamp();

  // Pause polling on pause, resume on play
  if (!audio._ccPollingSetup) {
    audio.on('pause', () => {
      clearTimeout(DISPATCH_INTERVAL);
    });
    audio.on('play', () => {
      clearTimeout(DISPATCH_INTERVAL);
      getTimeStamp();
    });
    audio.on('end', () => {
      store.dispatch(setCurrentCaption(''));
    });
    audio._ccPollingSetup = true;
  }
};

const initListeners = (audio, captions) => {
  const { captionsEnabled = true } = store.getState();

  if (!captionsEnabled || !captions) return;

  audio.on('play', () => syncAudioCaption(audio, captions));
};

const displayCaption = (audioTimeStamp, { cues } = {}) => {
  const timeStamp = audioTimeStamp.toFixed(1);
  const found = cues.find(({ start }) => formatTimeStamp(start) === timeStamp);

  if (found) {
    const { payload } = found;
    store.dispatch(setCurrentCaption(payload));
  }
};

const formatTimeStamp = time => {
  const [h, m, s] = time.split(':');
  return parseFloat(h * 3600 + m * 60 + s * 1).toFixed(1);
};

const HowlWithCCs = (howl, captions) => {
  initListeners(howl, captions);
  return howl;
};

export default HowlWithCCs;
